import { useEffect, useState } from "react";
import { apiEndPoints } from "../../ApiServices/config";
import { getApi, postApi } from "../../ApiServices/api";

const useGalleryData = (type) => {
  const [gallery, setGallery] = useState({
    list: [],
    categories: [],
    festival: [],
    tags: [],
  });

  const payload = {
    keyword: "",
    category: "",
    festival: "",
    tags: "",
    order: "asc",
    type,
  };

  const getEvent = async () => {
    try {
      const [galleryList, galleryCategories, galleryFestivals, galleryTags] =
        await Promise.all([
          postApi(apiEndPoints.allGallery, payload),
          getApi(apiEndPoints.galleryCategories),
          getApi(apiEndPoints.galleryFestivals),
          getApi(apiEndPoints.galleryTags),
        ]);

      setGallery({
        list: galleryList?.data?.status === 1 ? galleryList?.data?.data : [],
        categories:
          galleryCategories?.data?.status === 1
            ? galleryCategories?.data?.data
            : [],
        festival:
          galleryFestivals?.data?.status === 1
            ? galleryFestivals?.data?.data
            : [],
        tags:
          galleryTags?.data?.status === 1
            ? galleryTags?.data?.data
            : [],
      });
    } catch (error) {
      console.error("Failed to fetch gallery data:", error);
    }
  };

  useEffect(() => {
    getEvent();
  }, [type]);

  return {gallery};
};

export default useGalleryData;

export const useGalleryPhotos = (slug) => {
    const [photos, setPhotos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
  
    const fetchPhotos = async () => {
      setIsLoading(true);
      const payload = { slug };
      const res = await postApi(apiEndPoints.galleryPhotos, payload);
  
      if (res?.data?.status === 1) {
        setPhotos(res.data.data.photos);
      } else {
        setPhotos([]);
      }
  
      setIsLoading(false);
    };
  
    useEffect(() => {
      if (slug) fetchPhotos();
    }, [slug]);
  
    return { photos, isLoading };
};
 
